<app-master-data-table [data]="masterCommonService.productsList" [columns]="productColumns" title="Products List"
  addButtonLabel="Product" (add)="openAddUpdateProductDialog('add')"
  (update)="openAddUpdateProductDialog('update', $event)" (delete)="deleteProduct($event)">
</app-master-data-table>